export function findCloseBracket(code, startFrom = 0, brackets = "{}") {
    const [openBracket, closeBracket] = brackets;

    let opens = 1;

    for (let i = startFrom; i < code.length; i++) {
        const char = code[i];

        if ( char === openBracket ) {
            opens++;
        }
        if ( char === closeBracket ) {
            opens--;

            if ( opens === 0 ) {
                return i;
            }
        }
    }

    return -1;
}

export function shortestString(strings) {
    strings = strings.slice().sort((a, b) => a.length - b.length);
    return strings[0];
}